import { useLogger } from '@edreamsodigeo/frontend-core';
import { useEffect } from 'react';

const useFrontendApiLoggedError = (errors, id) => {
  const logger = useLogger();
  useEffect(() => {
    const errorStatus = errors?.status || 'ok';
    (errors || []).forEach((error) => {
      if (error?.extensions?.code !== 'ERR-01') {
        logger.error(
          error,
          `REQUEST-FEFR-${
            error?.extensions?.errorCode || error?.extensions?.code || '000'
          }-Status: ${errorStatus}-${id}-${error?.message}`
        );
      }
    });
  }, [errors, id, logger]);
};

export default useFrontendApiLoggedError;
